import React from "react";
import { Typography } from "@mui/material";

export default function Admin() {
  return (
    <div>
      <Typography variant="h5">Admin Page (Demo)</Typography>
      <Typography>View & manage all complaints and alerts here (future add-on).</Typography>
    </div>
  );
}
